import { render, staticRenderFns } from "./ClasseVirtuelleSingle.vue?vue&type=template&id=11f9440b&scoped=true&"
import script from "./ClasseVirtuelleSingle.vue?vue&type=script&lang=js&"
export * from "./ClasseVirtuelleSingle.vue?vue&type=script&lang=js&"
import style0 from "./ClasseVirtuelleSingle.vue?vue&type=style&index=0&id=11f9440b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f9440b",
  null
  
)

export default component.exports